import {
    hierarchy, treemap,
} from "d3-hierarchy"
import {
    scaleLinear,
} from "d3-scale"
import {select} from "d3-selection"
import React, {Component} from "react"
import styled from "styled-components"
import {
    Heading, Text,
} from "../../styled"
import {
    commonLocalization,
    number,
} from "../../../localization"
import { images } from "../../../config/index";
import NoData from "../../layouts/noData"


export default class Treemap extends Component {
    constructor(props) {
        super(props)
        this.state = {
            colors: ['#FBE4A9', '#F6D368', '#ECC417', '#E4B800', '#A88800'],
        }
        this.ref = React.createRef()
    }

    prepareData() {
        const categoryObj = this.props.data.projectsStats.data.data.category_wise
        let chartData = []

        if (categoryObj) {
            const {selectedWard} = this.props

            const keys = Object.keys(categoryObj)
            const items = keys.map(item => categoryObj[item])

            chartData = items.map((item, i) => {
                const key = keys[i]
                const {
                    title_en, title_ne,
                } = item.title

                const value = typeof selectedWard === 'number' ? item.ward_wise[selectedWard] && item.ward_wise[selectedWard].total.count || 0 : categoryObj[key].overall.total.count

                return {
                    name: key, title_en, title_ne, value: value,
                }
            })

            chartData = chartData.sort((a, b) => a.value - b.value).reverse()
        }

        return chartData
    }

    removeExstingChart() {
        const chartEl = document.querySelector('.tree-chart');
        if (chartEl) {
            chartEl.innerHTML = ''
        }
    }

    findColor(n) {
        const {rangeArr} = this.legendData()
        let rangeIndex;

        rangeArr.forEach((range, index) => {
            const minValue = range[0]
            const maxValue = range[1]

            if (index === 0) {
                if (n < maxValue || n === maxValue) {
                    rangeIndex = index
                    return
                }
            }

            if (minValue === n || n > minValue && n < maxValue || n === maxValue) {
                rangeIndex = index
                return
            }

            if (index === rangeArr.length - 1) {
                if (n > minValue) {
                    rangeIndex = index
                }
            }
        })

        return this.state.colors[rangeIndex]
    }

    findMaxAndMinProjects() {
        const data = this.prepareData()
        let max
        let min

        if (data.length) {
            max = Math.max(...data.map(o => o.value));
            min = Math.min(...data.map(o => o.value));
        }

        return {max, min}
    }

    legendData() {
        const rangeArr = []
        const {max, min} = this.findMaxAndMinProjects()
        const colors = this.state.colors

        function formatValue(value) {
            return value
        }

        const range = x => formatValue(Math.ceil((1 / colors.length * x * (max - min)) + min))

        const legend = colors.map((color, i) => {
            const min = range(i)
            const max = range(i + 1)
            let value = `${min} - ${max}`

            if (i === 0) {
                value = `< ${max}`
            }

            if (i === (colors.length - 1)) {
                value = `> ${min}`
            }

            rangeArr.push([min, max])

            value = number(value)

            return {color, value}
        })

        return {legend, rangeArr}
    }

    render() {
        this.removeExstingChart()
        const {chartHelpText, chartTitle, selectedLanguage} = this.props
        const {legend} = this.legendData()
        const data = {
            "name": "Treemap", "children": [],
        }

        let preaParedData = this.prepareData()

        preaParedData.forEach(item => item.color = this.findColor(item.value))

        data.children = preaParedData
        // sending data which has total values greater than 0
        data.children = data.children.filter(item => item.value > 0)

        let height = 100
        let width = 100


        if (data.children && data.children.length) {
          let x = scaleLinear().domain([0, width]).range([0, width]);
          let y = scaleLinear().domain([0, height]).range([0, height]);

          const svg = this.ref.current;

          let nodes = hierarchy(data).sum(function (d) {
            return d.value;
          });

          let treemapChart = treemap()
            .size([width, height])
            .paddingInner(0)
            .round(false);

          treemapChart(nodes);

          let cells = select(svg)
            .selectAll(".node")
            .data(nodes.descendants())
            .enter()
            .append("div")
            .attr("class", function (d) {
              return `node level-${d.depth} node-${d.data.name}`;
            })
            .on("mouseenter", function (d) {
              const tooltip = document.querySelector(".tooltip-treemap");
              const value = d.value;

              const html = `
                         <b> ${
                           selectedLanguage === "en"
                             ? "Projects"
                             : "परियाेजनाहरु"
                         } </b>- ${number(value)}
                  `;
              tooltip.innerHTML = html;
              tooltip.classList.add("show");

              let left = this.offsetLeft + this.offsetWidth / 2;
              const top = this.offsetTop + this.offsetHeight / 2;

              tooltip.style.top = top + "px";

              // mobile tooltip adding from the right side

              if (document.body.offsetWidth < 600) {
                // ading 8px - because tooltip arrow 8 px from the right
                left = left + 8 - tooltip.offsetWidth;

                tooltip.classList.add("tooltip-arrow-right");
              }

              tooltip.style.left = left + "px";
            })
            .on("mouseout", function (e) {
              const tooltip = document.querySelector(".tooltip-treemap");
              tooltip.classList.remove("show");
            });

          cells
            .style("left", function (d) {
              return x(d.x0) + "%";
            })
            .style("top", function (d) {
              return y(d.y0) + "%";
            })
            .style("width", function (d) {
              return x(d.x1) - x(d.x0) + "%";
            })
            .style("height", function (d) {
              return y(d.y1) - y(d.y0) + "%";
            })
            .style("background", function (d) {
              return d.data.color;
            })
            .append("p")
            .attr("class", "tree-chart-label")
            .html(function (d) {
              const { title_ne, title_en } = d.data;
              const html = `
                                <span>${
                                  selectedLanguage === "en"
                                    ? title_en
                                    : title_ne
                                }</span>
                  `;
              return html;
            });
        } 
        else {
          if (this.ref.current) {
            const { dataNotAvailable } = commonLocalization[selectedLanguage];

            const noData = `<div class="data-not-available">
                <img
                    src=${images.dataNotAvailable}
                    alt="data not available"
                />
                <Text.span>${dataNotAvailable}</Text.span>
            </div>`;
            this.ref.current.innerHTML = noData;
          }
        }

        return (<MainWrapper className={"flex flex-col"} lang={selectedLanguage}>
            <Heading.h2 uppercase className="chart-label flex items-center">
                <Text.span className="help-text">
                    <Text.span className="help-text__icon"><img className="help-icon" height={18} width={18} src={images.icons.help} alt="help" /></Text.span>
                    <Text.span className="help-text__content tooltip">
                        <Text.span className="tooltip-arrow">arrow</Text.span>
                        {chartHelpText}
                    </Text.span>
                </Text.span>
                <Text.span style={{opacity: 0.7}}>
                    {chartTitle}
                </Text.span>
            </Heading.h2>
            <div className={'relative grid gap-4'}>
                <div className="tooltip-treemap"></div>
                <div className="card relative category-chart">
                    <div ref={this.ref}></div>
                </div>
                <div className="treemap-legend">
                    <ul className={'flex flex-wrap'}>
                        {legend.map((item, index) => {
                            return (<li className="treemap-legend-item grid gap-2" key={index}>
                                <div className="treemap-legend-bg" style={{backgroundColor: item.color}}></div>
                                <div className="treemap-legend-text text-center"> {item.value}</div>
                            </li>)
                        })}
                    </ul>
                </div>
            </div>
        </MainWrapper>)
    }
}

const MainWrapper = styled.div`
 .category-chart {
  position: relative;
  padding: 0;
  background: #3b4155;
  height: 450px;
  overflow: hidden;
  border-radius: 6px;

  .tree-chart {
    position: absolute;
    top: -1px;
    right: -1px;
    left: -1px;
    bottom: -1px;
  }
}

.node {
  position: absolute;
  background: transparent no-repeat 50% / cover;
  border: 1px rgba(255,255,255,.3) solid;
  transition: opacity .8s;

  .tree-chart-label {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: color .4s, opacity .8s, filter .8s;
    font-size: 12px;
    font-weight: 700;
    pointer-events: none;
    color: black;
  }

  &.hide {
    opacity: 0;
    pointer-events: none;
  }

  &.hide .tree-chart-label {
    filter: blur(10px);
  }

  &.level-0 {
    z-index: 4;
    display: none;
  }

  &.level-1 {
    z-index: 3;
  }

  &.level-2 {
    z-index: 2;
    color: transparent;
  }

  &.level-3 {
    z-index: 1;
  }
}

.btn-back {
  position: absolute;
  top: 24px;
  right: 24px;
  padding: 8px 12px;
  border: 0;
  border-radius: 2px;
  background-color: rgba(0, 0, 0, .4);
  color: black;
  cursor: pointer;
  z-index: 99;

  &:hover {
    background-color: rgba(0, 0, 0, .6);
  }
}

.text-white{
  color: #fff !important;
}

.tooltip-treemap {
  background: #fff;
  padding: 16px;
  color: black;
  transform: translate( 0, calc(-50% - 48px));
  z-index: 99;
  position: absolute;
  display: flex;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;

  &:before{
    content: '';
    left: 0;
    position: absolute;
    bottom: -8px;
    border-top: 8px solid #fff;
    border-right: 8px solid transparent;
  }
  
  b{font-weight: bold}
}

 .tooltip-arrow-right:before{
   bottom: -7px;
   left: auto;
   right: 6px;
   border-left: 8px solid transparent;
   border-width: 7px;
  }

.tooltip-treemap.show {
  opacity: 1;
  visibility: visible;
}

.legend {
width: 50%;
margin-top: -80px;

ul {
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    list-style: none;
}

li {
    margin-bottom: 6px;
    text-align: center;
    font-size: 80%;
    list-style: none;
}

span {
    display: block;
    height: 15px;
}
}

.treemap-legend-item{
    text-align: center;
    .treemap-legend-bg{
      background: #ECC417;
      padding: 8px;
      width: 68px;
    }
}
h2 {
    font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
    > span:last-child {
    font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
    opacity: 0.7;
    }
    }
`



// WEBPACK FOOTER //
// ./src/components/visualization/treemap-chart/treemap.js